import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AI_Banner from "../../../assets/img/banner/Untitled design (18).webp";

const Block_Chain = (props) => {
  const {
    pageTitle,
    titleClass,
    parentCategory,
    pageCategory,
    pageName,
    breadcrumbsImg,
    animatedFont,
    animatedFontsize,
  } = props;
  const bgStyle = {
    backgroundImage: `url(${breadcrumbsImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(rgb(31 6 78), rgb(100 100 100 / 49%))",
  };

  return (
    <div
      className="rs-breadcrumbs rs-rain-animate"
      style={{ ...bgStyle, position: "relative" }}
    >
      <div style={overlayStyle} />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumbs-inner pt-350 pb-300 md-pt-250 md-pb-180 sm-pt-200 sm-pb-80">
              <h1
                className={titleClass ? titleClass : "page-title text-center"}
              >
                {pageTitle ? pageTitle : "Breadcrumbs"}
              </h1>
              <ul>
                <li>
                  <Link to="/" className="active">
                    {parentCategory ? parentCategory : "Home"}
                  </Link>
                </li>
                {pageCategory ? (
                  <>
                    <li>
                      <Link to="/" className="active">
                        {pageCategory ? pageCategory : "Category"}
                      </Link>
                    </li>
                    <li>{pageName ? pageName : "Page Name"}</li>
                  </>
                ) : (
                  <li>{pageName ? pageName : "Page Name"}</li>
                )}
              </ul>
              <h2 className={animatedFont ? animatedFont : "lined-Font"}>
                {animatedFontsize ? animatedFontsize : "page-title"}
              </h2>
            </div>
          </div>
          {/* <div className="col-lg-6 col-md-5 col-sm-12">
                           <div className="text-center pt-250 pb-150 md-pt-200 md-pb-120 sm-pt-50 sm-pb-50">
                             <img
                               className="bread_main_img"
                               src={bannerbg}
                               alt="Company-Overview"
                               loading="lazy"
                             />
                           </div>
                         </div> */}
        </div>
        <div className="line-inner style2">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    </div>
  );
};

export default Block_Chain;
